import { SectionAction, SectionState } from './interfaces';

// TODO: use a shared reducer
export const getInitialState: <T>() => SectionState<T> = () => ({
  crud: { open: false, record: null, mode: null },
  deleteModal: { open: false, record: null },
});

export function reducer<T>(prevState: SectionState<T>, action: SectionAction<T>): SectionState<T> {
  switch (action.type) {
    case 'openCrud':
      if (!action.mode) throw new Error(`Invalid action provided ${action.type}`);
      return {
        ...getInitialState(),
        crud: { open: true, record: action.record ?? null, mode: action.mode },
      };
    case 'closeCrud':
      return {
        ...getInitialState(),
      };
    case 'openDeleteModal':
      if (!action.record) throw new Error(`Invalid action provided ${action.type}`);
      return {
        ...prevState,
        deleteModal: {
          open: true,
          record: action.record,
        },
      };
    case 'closeDeleteModal':
      return {
        ...prevState,
        deleteModal: {
          open: false,
          record: null,
        },
      };
    default:
      throw new Error('No action provided');
  }
}
